<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42 10H6a2 2 0 00-2 2v24a2 2 0 002 2h36a2 2 0 002-2V12a2 2 0 00-2-2zm0 26H6V12h36z"/><path d="M17 34h14a1 1 0 001-1V21a1 1 0 00-1-1h-.56a3.91 3.91 0 00.56-2 4 4 0 00-7-2.62A4 4 0 0017 18a3.91 3.91 0 00.56 2H17a1 1 0 00-1 1v12a1 1 0 001 1zm1-6h5v4h-5zm12-2h-5v-4h5zm-7 0h-5v-4h5zm2 6v-4h5v4zm2-16a2 2 0 010 4h-2v-2a2 2 0 012-2zm-8 2a2 2 0 014 0v2h-2a2 2 0 01-2-2z"/></svg>